import * as types from "./types";

const mutations = {
	// Проверка аутентификации
	[types.CHECK_AUTH](
		state: { checkAuthState: object },
		checkAuthState: object
	) {
		state.checkAuthState = checkAuthState;
	},

	// Проверяем, зарегистрирован номер или нет.
	[types.CHECK_REGISTERED](
		state: { checkRegisteredState: object },
		checkRegisteredState: object
	) {
		state.checkRegisteredState = checkRegisteredState;
	},

	// Генерация проверочного кода
	[types.LOGIN_CONFIRMATION_CODE](
		state: { loginConfirmationCodeState: object },
		loginConfirmationCodeState: object
	) {
		state.loginConfirmationCodeState = loginConfirmationCodeState;
	},

	// Выход из системы
	[types.LOGOUT](state: { logoutState: object }, logoutState: object) {
		state.logoutState = logoutState;
	},
};

export default mutations;
